import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import {
  PortalAddresses,
  PortalCoreReturn,
  PortalCoreReturns,
  PortalDistributorCustomers,
  PortalDistributorRequestDetail,
  PortalDistributorRequests,
  PortalHome,
  PortalOrderDetail,
  PortalOrders,
  PortalProfile,
  PortalValveBodies,
  PortalValveBodyDetail,
  PortalWarrantyChat,
  PortalWarrantyClaim,
  PortalWarrantyCreate,
  PortalSupport,
  PortalSupportCompose,
  PortalSupportThread,
} from "./portal";

/** @type {import('../types').MobileTenantModule} */
const mx = {
  key: "mx",
  label: "VBS Mexico",
  domains: ["vbspecialties.com.mx", "www.vbspecialties.com.mx"],
  codePath: "public-web/src/mobile/mx",
  pages: {
    home: HomePage,
    download: HomePage,
    catalog: CatalogPage,
    productDetail: ProductDetailPage,
    cart: CartPage,
    checkout: CheckoutPage,
    portalHome: PortalHome,
    portalOrders: PortalOrders,
    portalOrderDetail: PortalOrderDetail,
    portalDistributorRequests: PortalDistributorRequests,
    portalDistributorRequestDetail: PortalDistributorRequestDetail,
    portalDistributorCustomers: PortalDistributorCustomers,
    portalValveBodies: PortalValveBodies,
    portalValveBodyDetail: PortalValveBodyDetail,
    portalCoreReturns: PortalCoreReturns,
    portalCoreReturn: PortalCoreReturn,
    portalWarrantyCreate: PortalWarrantyCreate,
    portalWarrantyClaim: PortalWarrantyClaim,
    portalWarrantyChat: PortalWarrantyChat,
    portalSupport: PortalSupport,
    portalSupportCompose: PortalSupportCompose,
    portalSupportThread: PortalSupportThread,
    portalProfile: PortalProfile,
    portalAddresses: PortalAddresses,
  },
};

export default mx;
